import { selectActiveIndex, selectIppicaTodayCorseDaylist } from 'features/ippica/selectors';
import { useTypedSelector } from 'lib/centralStore';
import dynamic from 'next/dynamic';
import { IppicaEmpty } from '../../ippicaEmpty';
import { IppicaTableRow } from '../../ippicaTableRow';
export const DynamicIppicaWithTabTableCorseRenderer = dynamic(() =>
  import('features/ippica/components/ippicaWithTabTable/ippicaWithTabTableCorseRenderer').then(
    (mod) => mod.IppicaWithTabTableCorseRenderer
  )
);
export type IppicaWithTabTableCorseRendererProps = {
  _?: number;
};
export const IppicaWithTabTableCorseRenderer = ({ _ }: IppicaWithTabTableCorseRendererProps) => {
  const corseList = useTypedSelector(selectIppicaTodayCorseDaylist);
  const activeIndex = useTypedSelector(selectActiveIndex);

  return (
    <>
      {!!corseList?.length && !!activeIndex ? (
        corseList[+activeIndex]?.map((keyAvvenimento) => {
          return <IppicaTableRow key={keyAvvenimento} keyAvvenimento={keyAvvenimento} />;
        })
      ) : (
        <IppicaEmpty hasMarginRight={true}>
          <span>Non ci sono dati disponibili</span>
        </IppicaEmpty>
      )}
    </>
  );
};
